// Script para mostrar sticky button apenas após scroll do botão normal
// Tema Stiletto - Shopify

(function() {
  'use strict';
  
  function initStickyButton() {
    // Encontrar elementos
    const stickyBar = document.querySelector('.sticky-atc-bar');
    const normalButton = document.querySelector('.product-form__cart-submit:not(.sticky-atc-bar__button .product-form__cart-submit)');
    
    if (!stickyBar || !normalButton) {
      console.log('Botões não encontrados, tentando novamente...');
      setTimeout(initStickyButton, 500);
      return;
    }
    
    // Esconder sticky button inicialmente
    stickyBar.style.cssText = `
      opacity: 0 !important;
      visibility: hidden !important;
      transform: translateY(100%) !important;
      transition: all 0.3s ease !important;
    `;
    
    // Função para verificar posição do scroll
    function checkScroll() {
      // Obter posição do botão normal
      const buttonRect = normalButton.getBoundingClientRect();
      const buttonBottom = buttonRect.bottom;
      
      // Se o botão normal passou do topo da tela (saiu da view)
      if (buttonBottom < 0) {
        // Mostrar sticky button
        stickyBar.style.cssText = `
          opacity: 1 !important;
          visibility: visible !important;
          transform: translateY(0) !important;
          transition: all 0.3s ease !important;
        `;
      } else {
        // Esconder sticky button
        stickyBar.style.cssText = `
          opacity: 0 !important;
          visibility: hidden !important;
          transform: translateY(100%) !important;
          transition: all 0.3s ease !important;
        `;
      }
    }
    
    // Verificar ao fazer scroll
    window.addEventListener('scroll', checkScroll);
    
    // Verificar ao redimensionar
    window.addEventListener('resize', checkScroll);
    
    // Verificar ao carregar
    checkScroll();
    
    console.log('Sticky button configurado com sucesso!');
  }
  
  // Executar quando DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyButton);
  } else {
    initStickyButton();
  }
  
})();